import React, { useEffect, useState } from 'react';

import { View, ViewFilters } from '@uncinc/react-drupal-core';
import { throttle } from 'lodash';
import useQueryParams from '../../../../helpers/useQueryString';
import Select from '../../../../components/Select';


import './style.scss';

const ViewFilterElementCustom = (props) => {
  const { filter, onChange, defaultValues } = props;
  let defaultValue = null;
  const options = [];

  if (typeof filter === 'undefined') {
    return (
      <div className="filter-item">
        Filter undefined
      </div>
    );
  }

  switch (filter.get('plugin_id')) {
    case 'string': {
      if (Object.keys(defaultValues).length >= 1) {
        defaultValue = defaultValues[filter.get('field')];
      }

      const throttledOnChange = throttle(((e) => {
        if (e) {
          onChange(filter.getIn(['expose', 'identifier'], filter.get('field')), e.target.value);
        }
      }), 500);

      return (
        <div className="filter-item input-with-unit input-with-unit--after" key={filter.get('field')}>
          <label htmlFor={filter.get('field')}>{filter.getIn(['expose', 'label'])}</label>
          <div className="input-container">
            <input
              type="text"
              name={filter.get('field')}
              id={filter.get('field')}
              value={defaultValue}
              placeholder={filter.getIn(['expose', 'placeholder'])}
              onChange={(e) => throttledOnChange(e)}
            />
            <div className="unit icon-after icon-search" />
          </div>
        </div>
      );
    }

    case 'taxonomy_index_tid_depth':
    case 'taxonomy_index_tid':
      options.push({ label: 'Toon alles', value: null });

      if (filter.get('options')) {
        filter.get('options').valueSeq().forEach((item) => {
          const value = item.get('value');
          const label = item.get('label');
          options.push({ value, label });

          if (item.get('children')) {
            item.get('children').map((subitem) => {
              const subvalue = subitem.get('value');
              const sublabel = subitem.get('label');
              options.push({ value: subvalue, label: <div><span className="indent" />{sublabel}</div> });
            });
          }
        });

        if (Object.keys(defaultValues).length >= 1) {
          defaultValue = options.filter((option) => option.value === String(defaultValues[filter.getIn(['expose', 'identifier'])]));
        }
      }

      return (
        <div className="Form__element" key={filter.get('field')}>
          <label htmlFor={filter.get('field')}>{filter.getIn(['expose', 'label'])}</label>
          <Select
            options={options}
            placeholder={filter.getIn(['expose', 'label'])}
            id={filter.get('field')}
            defaultValue={defaultValue}
            handleChange={(option) => onChange(filter.getIn(['expose', 'identifier'], filter.get('field')), [option.value])}
            isSearchable={false}
          />
        </div>
      );

    default:
      return (
        <div className="filter-item">
          Filter Element: {filter.get('plugin_id')}
        </div>
      );
  }
};

const getFiltersFromParams = (params) => {
  const newFilters = {};
  const keys = Object.keys(params);

  keys.forEach((key) => {
    newFilters[key] = params[key];
  });

  return newFilters;
};


const OverviewCausesAll = ({ id, display, entity, tids, page, setCurrentPage }) => {
  const [params, setParams] = useQueryParams();
  const [filters, setFilters] = useState(getFiltersFromParams(params));

  const updateFilter = (field, value) => {
    const newParams = {
      ...params,
      [field]: value,
    };

    setParams(newParams);
    setFilters(newParams);
  };

  useEffect(() => {
    setCurrentPage(0);
  }, [filters, setCurrentPage]);

  return (
    <div className="ViewWithFilters row no-gutters">
      <div className="col-12">
        <ViewFilters
          viewId={id}
          display={display === 'block_1' ? 'default' : display}
          onFilterUpdate={(field, value) => updateFilter(field, value)}
          onRender={(props) => (
            <ViewFilterElementCustom {...props} defaultValues={filters} />
          )}
        />
        <View id={id} display={display} filters={filters} page={page} setCurrentPage={setCurrentPage} />
      </div>
    </div>
  );
};

export default OverviewCausesAll;
